import React from "react";
import Metric from 'utils/Metric'
import getCurrencyDetails from 'utils/getCurrencyDetails'

function yy_for_metric(current, last_year) {
  if (last_year == null || current == null) {
    return "";
  }
  if (last_year == current) {
    return 0
  }
  return ((current - last_year) / last_year) * 100;
}

function formatted_metric(opts, isNull = false, lastYearNull = false, client) {

  if (isNull) {
    return "no data"
  }
  if (lastYearNull) {
    return "no data"
  }
  else if (opts.value === null) {
    if (opts.thisYear === null) {
      return ""
    }
    else {
      return "no data"
    }
  }
 

  opts.metricName = opts.metricName.toLowerCase();

  if (opts.metricName.includes("roas")) {
    let currencyDetails = getCurrencyDetails(opts.displayCurrency)
    return (
      <Metric client={client} metricName="roas" prefix={currencyDetails.prefix} value={opts.value} commas={true} precision={2} suffix="" />
    )
  } else if (opts.metricName.includes("revenue")) {
    let currencyDetails = getCurrencyDetails(opts.displayCurrency)
    return (
      <Metric baseCurrency={opts.baseCurrency} displayCurrency={opts.displayCurrency} prefix={currencyDetails.prefix} value={opts.value} commas={true} precision={0} suffix="" />
    )
  } else if (opts.metricName.includes("spend")) {
    let currencyDetails = getCurrencyDetails(opts.displayCurrency)
    return (
      <Metric baseCurrency={opts.baseCurrency} displayCurrency={opts.displayCurrency} prefix={currencyDetails.prefix} value={opts.value} commas={true} precision={0} suffix="" />
    )
  } else if (opts.metricName.includes("traffic")) {
    return <Metric value={opts.value} commas={true} precision={0} />
  } else if (opts.metricName.includes("impressions")) {
    return <Metric value={opts.value} commas={true} precision={0} />
  } else if (opts.metricName.includes("views")) {
    return <Metric value={opts.value} commas={true} precision={0} />
  } else if (opts.metricName.includes("add_to_carts")) {
    return <Metric value={opts.value} commas={true} precision={0} />
  } else if (opts.metricName.includes("earned_likes")) {
    return <Metric value={opts.value} commas={true} precision={0} />
  } else if (opts.metricName.includes("earned_shares")) {
    return <Metric value={opts.value} commas={true} precision={0} />
  } else if (opts.metricName.includes("checkouts_started")) {
    return <Metric value={opts.value} commas={true} precision={0} />
  } else if (opts.metricName.includes("clicks")) {
    return <Metric value={opts.value} commas={true} precision={0} />
  } else if (opts.metricName.includes("visits")) {
    return <Metric value={opts.value} commas={true} precision={0} />
  } else if (opts.metricName.includes("average_position")) {
    return <Metric value={opts.value} commas={true} precision={0} />
  } else if (opts.metricName.includes("top_ten_keywords_percentage")) {
    return <Metric value={opts.value} commas={true} precision={2} suffix={"%"} />
  } else if (opts.metricName.includes("top_ten_keywords")) {
    return <Metric value={opts.value} commas={true} precision={0} />
  } else if (opts.metricName.includes("top_twenty_keywords")) {
    return <Metric value={opts.value} commas={true} precision={0} />
  } else if (opts.metricName.includes("top_three_keywords")) {
    return <Metric value={opts.value} commas={true} precision={0} />
  } else if (opts.metricName.includes("ctr")) {
    return <Metric value={opts.value} commas={true} precision={2} suffix={"%"} />
  } else if (opts.metricName.includes("cart_to_conversion_rate")) {
    return <Metric value={opts.value} commas={true} precision={2} suffix={"%"} />
  } else if (opts.metricName.includes("impression_to_cart_rate")) {
    return <Metric value={opts.value} commas={true} precision={2} suffix={"%"} />
  } else if (opts.metricName.includes("social_view_rate")) {
    return <Metric value={opts.value} commas={true} precision={2} suffix={"%"} />
  } else if (opts.metricName.includes("view_rate")) {
    return <Metric value={opts.value} commas={true} precision={2} suffix={"%"} />
  } else if (opts.metricName.includes("bounce_rate")) {
    return <Metric value={opts.value} commas={true} precision={2} suffix={"%"} />
  } else if (opts.metricName.includes("search_visibility")) {
    return <Metric value={opts.value} commas={true} precision={2} suffix={"%"} />
  } else if (opts.metricName.includes("cpc")) {
    let currencyDetails = getCurrencyDetails(opts.displayCurrency)
    return (
      <Metric baseCurrency={opts.baseCurrency} displayCurrency={opts.displayCurrency} prefix={currencyDetails.prefix} value={opts.value} commas={true} precision={2} suffix="" />
    )
  } else if (opts.metricName.includes("conversions")) {
    return <Metric value={opts.value} commas={true} precision={0} />
  } else if (opts.metricName.includes("conversion rate")) {
    return <Metric value={opts.value} commas={true} precision={2} suffix={"%"} />
  } else if (opts.metricName.includes("cr")) {
    return <Metric value={opts.value} commas={true} precision={2} suffix={"%"} />
  } else if (opts.metricName.includes("cvr")) {
    return <Metric value={opts.value} commas={true} precision={2} suffix={"%"} />
  } else if (opts.metricName.includes("cpa")) {
    let currencyDetails = getCurrencyDetails(opts.displayCurrency)
    return (
      <Metric baseCurrency={opts.baseCurrency} displayCurrency={opts.displayCurrency} prefix={currencyDetails.prefix} value={opts.value} commas={true} precision={2} suffix="" />
    )
  } else if (opts.metricName.includes("cpv")) {
    let currencyDetails = getCurrencyDetails(opts.displayCurrency)
    return (
      <Metric baseCurrency={opts.baseCurrency} displayCurrency={opts.displayCurrency} prefix={currencyDetails.prefix} value={opts.value} commas={true} precision={2} suffix="" />
    )
  } else if (opts.metricName.includes("aov")) {
    let currencyDetails = getCurrencyDetails(opts.displayCurrency)
    return (
      <Metric baseCurrency={opts.baseCurrency} displayCurrency={opts.displayCurrency} prefix={currencyDetails.prefix} value={opts.value} commas={true} precision={2} suffix="" />
    )
  } else if (opts.metricName.includes("phone_calls")) {
    return <Metric value={opts.value} commas={true} precision={0} />
  } else if (opts.metricName.includes("cpm")) {
    let currencyDetails = getCurrencyDetails(opts.displayCurrency)
    return (
      <Metric baseCurrency={opts.baseCurrency} displayCurrency={opts.displayCurrency} prefix={currencyDetails.prefix} value={opts.value} commas={true} precision={0} suffix="" />
    )
  } else if (opts.metricName.includes("yy")) {
    return <Metric value={opts.value} commas={true} precision={0} suffix={"%"} />
  } else {
    return "INVALID METRIC";
  }
}

class MetricTableRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lockColumns: {},
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lockColumns !== this.props.lockColumns) {
      this.setState({
        lockColumns: this.props.lockColumns,
      });
    }
  }
  render() {
    const date = new Date()
    let month = date.getMonth() + 1
    let isThisYearNull = this.props.rowNumber <= month && this.props.thisYearValue === null
    let isLastYearNull = this.props.lastYearValue === null
    let shouldRenderBottomBorder = this.props.rowNumber % 3 != 0;
    let yy = yy_for_metric(this.props.thisYearValue, this.props.lastYearValue);
    let firstValueClass = shouldRenderBottomBorder && !this.props.bottomRow ? "no-border" : "no-border-lrt";
    let secondValueClass = shouldRenderBottomBorder && !this.props.bottomRow ? "no-border" : "no-border-lrt";
    let thirdValueClass = "";
    let metricTitle = _.startCase(_.camelCase(this.props.metricName));
    if (metricTitle.includes("Roas")) {
      metricTitle = metricTitle.slice(0, -4) + metricTitle.slice(-4).toUpperCase();
    }
    if (metricTitle.includes("Aov")) {
      metricTitle = metricTitle.slice(0, -3) + metricTitle.slice(-3).toUpperCase();
    }

    if (metricTitle.includes("Cpa")) {
      metricTitle = metricTitle.slice(0, -3) + metricTitle.slice(-3).toUpperCase();
    }
    if (metricTitle.includes("Cvr")) {
      metricTitle = "Conv. Rate";
    }
    if (metricTitle === "Traffic") {
      metricTitle = "Organic Traffic";
    }
    if (typeof yy == "string" || yy >= 0) {
      if (typeof yy == "string") {
        thirdValueClass += "";
      } else if (this.props.metricName === "click_cpa" || this.props.metricName == "cpc" || this.props.metricName == "total_cpa") {
        if (yy == 0) {
          thirdValueClass = ""
        }
        else {
          thirdValueClass += "yy-text-negative";
        }
      } 
      else if (Number.isFinite(yy))  {
        thirdValueClass += "yy-text-positive";
      }
    } else if (!Number.isFinite(yy) || yy == 0) {
      thirdValueClass += "";
    } else if (this.props.metricName === "click_cpa" || this.props.metricName == "cpc" || this.props.metricName == "total_cpa") {
      thirdValueClass += "yy-text-positive";
    } else {
      thirdValueClass += "yy-text-negative";
    }

    if (shouldRenderBottomBorder && !this.props.bottomRow) {
      thirdValueClass += " empty3 no-border-ltb";
    } else {
      thirdValueClass += " empty3 no-border-lt";
    }
    return (
      <React.Fragment>
        {this.state.lockColumns[`${metricTitle}`] == true ? (
          <>
            <td className={this.props.lastYearValue == null ? `${firstValueClass} metric-data-cell lock1 null-value-td` : `${firstValueClass} metric-data-cell lock1`} style={{ left: `${110 + 290 * this.props.indexOf}px` }}>
              <div className={this.props.lastYearValue == null ? `null-value` : ``}>
                {formatted_metric({
                  metricName: this.props.metricName,
                  value: this.props.lastYearValue,
                  baseCurrency: this.props.baseCurrency,
                  displayCurrency: this.props.displayCurrency
                }, false, isLastYearNull, this.props.client)}
              </div>
            </td>
            <td className={isThisYearNull ? `${secondValueClass} metric-data-cell lock2 null-value-td` : `${secondValueClass} metric-data-cell lock2`}style={{ left: `${220 + 290 * this.props.indexOf}px` }}>
             <div className={isThisYearNull ? `null-value` : ``}>
                {formatted_metric({
                  metricName: this.props.metricName,
                  value: this.props.thisYearValue,
                  baseCurrency: this.props.baseCurrency,
                  displayCurrency: this.props.displayCurrency,
                  thisYear: this.props.thisYearValue
                }, isThisYearNull, false, this.props.client)}
              </div>
            </td>
            <td
              className={`${thirdValueClass} lock3 ${Number.isNaN(yy) && "empty3"}`}
              style={{ textAlign: "center", minWidth: "30px", left: `${330 + 290 * this.props.indexOf}px` }}>
              {" "}
              {!Number.isFinite(yy) ? "" : typeof yy == "string" ? "" : yy.toFixed(0).toString() + "%"}{" "}
            </td>
          </>
        ) : (
          <>
            <td className={this.props.lastYearValue == null ?`${firstValueClass} metric-data-cell null-value-td` : `${firstValueClass} metric-data-cell `}>
              <div className={this.props.lastYearValue == null ? `null-value` : ``}>
                {formatted_metric({
                  metricName: this.props.metricName,
                  value: this.props.lastYearValue,
                  baseCurrency: this.props.baseCurrency,
                  displayCurrency: this.props.displayCurrency,
                  lastYear: this.props.lastYearValue
                }, false, isLastYearNull, this.props.client)}
              </div>
            </td>
            <td className={isThisYearNull ? `${secondValueClass} metric-data-cell null-value-td` : `${secondValueClass} metric-data-cell `}>
             <div className={isThisYearNull ? `null-value` : ``}>
              {formatted_metric({
                metricName: this.props.metricName,
                value: this.props.thisYearValue,
                baseCurrency: this.props.baseCurrency,
                displayCurrency: this.props.displayCurrency,
                thisYear: this.props.thisYearValue
              }, isThisYearNull, false, this.props.client)}
              </div>
            </td>
            <td className={`${thirdValueClass} `} style={{ textAlign: "center", minWidth: "30px", background: "inherit" }}>
            {!Number.isFinite(yy) ? "" : typeof yy == "string" ? "" : yy.toFixed(0).toString() + "%"}{" "}
            </td>
          </>
        )}
      </React.Fragment>
    );
  }
}

export default MetricTableRow;

